<template>
   <div class="container-fluid h-100 w-100 backgroundPage">
      <div class="row h-100 d-flex justify-content-center align-items-center">
          <div class=" col-md-8  imageContent">
              <img :src="require(`../../assets/images/${this.code}.png`)" class="h-100" alt="" srcset="">
          </div>
          <div class="col-md-4 d-flex flex-column gap-3">
              <h1 class="text-danger">ERROR <span class="statusCodde mb-1">{{this.code}}</span></h1>
              <p class="text-uppercase text-danger">{{this.message}}</p>
              <button @click.prevent="goBackFunction" class="btnCss">
                Go Back
              </button>
          </div>
      </div>
   </div>
</template>

<script>
    export default {
        name:'first-page',
        async mounted(){

            console.log(this.$route.params)
            this.code = this.$route.params.code ? this.$route.params.code :  this.code;
            this.message = this.$route.params.message ? this.$route.params.message :  this.message;

            this.permissions = await this.$store.state?.auth?.user ? this.$store.state.auth.permissions : [];
            this.roles = await this.$store.state?.auth?.user ? this.$store.state?.auth?.user.data.role : [];
        },
        data(){
            return {
                code: 404,
                message: "Page Not Found",
                permissions:[],
                roles:[],
                urls: ['template', 'competition', 'training', 'userscore', 'setting', 'entity'],
                routes: {
                    'template': 'templates',
                    'competition': 'competitions',
                    'training': 'trainings',
                    'userscore': 'results',
                    'setting' : 'settings/roles',
                    'entity' : 'settings/entities',
                }
            }
        },
        methods:{
            async goBackFunction (){

                let url = '/';
                if(+this.code === 401){
                    url = '/login';
                }else{
                    if(this.roles.includes('user')){
                        url='/user-competitions';
                    }else if(this.roles.includes('super_admin')){
                        url='/organizations';
                    }else{
                        for (let idx = 0; idx < this.urls.length; idx++) {
                            if (this.permissions.includes('viewAny ' + this.urls[idx])) {
                                url = '/' +this.routes[this.urls[idx]];
                                break;
                            }
                        }
                    }
                }

                await this.$router.push({path: url});
            }
        }
    }
</script>

<style scoped>
    .btnCss{
        background-color: #e65c00;
        color: #fff;
        text-decoration: none;
        width:50%;
        text-align: center;
        border-radius: 5px;
        padding: 10px;
        border: none;
    }
    .backgroundPage{
        background-color: #fff;
    }
    .imageContent{
        /*background-image: url("");*/
    }
    .statusCodde{
        color: #e65c00;
    }
</style>